import React from "react";
import { useEffect, useState } from "react";
import { useNavigate, Routes, Route, useLocation, Navigate } from "react-router-dom";
import SessionCard from "./components/SessionCard";
import Header from "./components/Header";
import { listSessions } from "./api";
import SecondPage from "./components/SecondPage";
import ConversationPage from "./components/ConversationPage";
import Home from "./components/Home/Home";
import SessionsList from "./components/SessionsList";
import LiveAvatarEmbed from "./components/LiveAvatarEmbed";
import Signup from "./components/Login/Signup";
import Login from "./components/Login/Login";

// Protected Route Component
function ProtectedRoute({ children }) {
  const isAuthenticated = localStorage.getItem('isAuthenticated') === 'true' && 
                          localStorage.getItem('access_token');
  
  if (!isAuthenticated) {
    // Clear any stale data
    localStorage.removeItem('access_token');
    localStorage.removeItem('token_type');
    localStorage.removeItem('user_id');
    localStorage.removeItem('user_name');
    localStorage.removeItem('user_email');
    localStorage.removeItem('isAuthenticated');
    
    return <Navigate to="/" replace />;
  }
  
  return children;
}
 
export default function App() {
  const navigate = useNavigate();
  const location = useLocation();
  
  // Hide header on login/signup pages
  const hideHeader = location.pathname === "/" || location.pathname === "/signup";
  
  // Redirect authenticated users away from login/signup pages
  useEffect(() => {
    const isAuthenticated = localStorage.getItem('isAuthenticated') === 'true' && 
                            localStorage.getItem('access_token');
    
    if (isAuthenticated && (location.pathname === "/" || location.pathname === "/signup")) {
      navigate('/home', { replace: true });
    }
  }, [location.pathname, navigate]);
 
  return (
    <div className="min-h-screen bg-gray-50">
      {!hideHeader && <Header />}
      <Routes>
        {/* Login page - Default */}
        <Route path="/" element={<Login />} />
        
        {/* Signup page */}
        <Route path="/signup" element={<Signup />} />
        
        {/* Protected Routes */}
        <Route 
          path="/home" 
          element={
            <ProtectedRoute>
              <Home />
            </ProtectedRoute>
          } 
        />
        
        <Route 
          path="/session/:id" 
          element={
            <ProtectedRoute>
              <SecondPage />
            </ProtectedRoute>
          } 
        />
        
        <Route 
          path="/conversation/:sessionId" 
          element={
            <ProtectedRoute>
              <ConversationPage />
            </ProtectedRoute>
          } 
        />
        
        <Route 
          path="/sessions" 
          element={
            <ProtectedRoute>
              <SessionsList />
            </ProtectedRoute>
          } 
        />

        <Route 
          path="/liveavatar-embed" 
          element={
            <ProtectedRoute>
              <LiveAvatarEmbed />
            </ProtectedRoute>
          } 
        />

      </Routes>
    </div>
  );
}